import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ProgressBarTableDesktop from '/@/components/crop-monitoring/progress-bar-cp-dskt/desktop';
import ProgressBarTableMobile from '/@/components/crop-monitoring/progress-bar-cp-dskt/mobile';
import { getCropProtectionProducts } from '/@/store/crop-monitoring/selectors';

const ProgressBarTable = ({ steps, activeStep, type = 'desktop', technology, expectedFloweringDate }) => {
    const [productsData, setProductsData] = useState([]);
    const [modalOpened, setModalOpened] = useState(false);
    const [modalProduct, setModalProduct] = useState(null);
    const [modalState, setModalState] = useState(undefined);
    const unformattedData = useSelector(getCropProtectionProducts);
    const stageNames = steps.filter((el) => !el.empty).map((el) => el.state);

    const getProductsData = () => {
        let filteredData = unformattedData.filter((pd) => {
            return pd.technology.name === technology;
        });

        const lastStep = steps[steps.length - 1];

        if (lastStep.stage === 'maturity') {
            const currentStages = steps.filter((el) => !el.empty).map(({ state }) => state); //.concat('FM');
            filteredData = filteredData
                .filter(({ stage: { name } }) => currentStages.includes(name))
                .map((row) => {
                    return { ...row, stage: { ...row.stage, column: currentStages.indexOf(row.stage.name) + 1 } };
                });
        }

        const formattedData = Object.values(
            filteredData.reduce((rows, el) => {
                // Add row
                if (!rows.hasOwnProperty(el.row)) rows[el.row] = {};
                const row = rows[el.row];

                // Add Col (Data cannot have two identical columns in a row)
                row[el.stage.column] = el;
                return rows;
            }, {})
        ).map((row) => {
            return Object.keys(row)
                .sort((a, b) => a - b)
                .reduce((cols, colIndex) => {
                    const lastCol = cols[cols.length - 1];
                    if (lastCol) {
                        const lastColIndex = lastCol.stage.column;
                        [...Array(colIndex - lastColIndex - 1).keys()].forEach((_) => {
                            cols.push({ product: {} });
                        });
                    } else if (colIndex > 1) {
                        [...Array(colIndex - 1).keys()].forEach((_) => {
                            cols.push({ product: {} });
                        });
                    }
                    cols.push(row[colIndex]);
                    return cols;
                }, []);
        });

        setProductsData(formattedData);
    };

    useEffect(() => {
        if (unformattedData.length) {
            getProductsData();
        }
    }, [technology, unformattedData]);

    const openModal = (product, startStage, cols) => {
        const start = startStage * 2;
        const end = start + cols * 2;
        setModalProduct(product);

        if (activeStep < start) {
            setModalState('future');
        } else if (activeStep >= start && activeStep < end) {
            setModalState('present');
        } else {
            setModalState('past');
        }

        setModalOpened(true);
    };

    if (type === 'desktop') {
        return (
            <ProgressBarTableDesktop
                steps={steps}
                activeStep={activeStep}
                productsData={productsData}
                stageNames={stageNames}
                modalOpened={modalOpened}
                modalProduct={modalProduct}
                modalState={modalState}
                setModalOpened={setModalOpened}
                openModal={openModal}
            ></ProgressBarTableDesktop>
        );
    } else {
        return (
            <ProgressBarTableMobile
                steps={steps}
                activeStep={activeStep}
                productsData={productsData}
                stageNames={stageNames}
                modalOpened={modalOpened}
                modalProduct={modalProduct}
                modalState={modalState}
                setModalOpened={setModalOpened}
                openModal={openModal}
                expectedFloweringDate={expectedFloweringDate}
            ></ProgressBarTableMobile>
        );
    }
};

export default ProgressBarTable;
